import { useSearchParams } from 'react-router';

import { Suspense } from '#src/atoms/Suspense/index.tsx';
import { Backdrop } from '#src/atoms/loader/Backdrop/index.tsx';

export enum DialogKey {
  news = 'news',
  claimedConversionCredit = 'claimedConversionCredit',
  deliveryItemOrder = 'deliveryItemOrder',
  card = 'card',
  bundledAuction = 'bundledAuction',
  primaryOfferBought = 'primaryOfferBought',
  paypalTransactionId = 'transactionId',
  unblockWallet = 'unblockWallet',
  game = 'game',
  eventType = 'eventType',
  auction = 'auction',
  primaryOffer = 'primaryOffer',
  verifyPhone = 'verifyPhone',
  checkout = 'checkout',
  upcomingTrack = 'upcomingTrack',
  competitionDrawer = 'competitionDrawer',
  contender = 'contender',
  connect_campaign = 'connect_campaign',
  connected_user_slug = 'connected_user_slug',
  singleSaleOffer = 'singleSaleOffer',
  buyGems = 'buy_gems',
  cardPack = 'cardPack',
  packDetails = 'packDetails',
  welcomePack = 'welcomePack',
  decisivePlayerPicker = 'decisivePlayerPicker',
  jonumVerification = 'jonumVerification',
  guessTheScoreTask = 'guessTheScoreTask',
  duoInvite = 'duoInvite',
  hub = 'hub',
  inbox = 'inbox',
  friends = 'friends',
  addFriends = 'addFriends',
  activityReactions = 'activityReactions',
}

export enum DialogAdditionalParamKey {
  playerSlugs = 'playerSlugs',
  trckGrp = 'trckGrp',
  trck = 'trck',
  arena = 'arena',
  prizePoolTab = 'prizePoolTab',
  hideFixtureCompetitionTabs = 'hideFixtureCompetitionTabs',
  previousSaleOffer = 'previousSaleOffer',
  gemsNeeded = 'gemsNeeded',
  slotIndex = 'slotIndex',
  reactionEmoji = 'reactionEmoji',
  friendsTab = 'friendsTab',
}

export const WithDialogs = ({
  children,
  dialogs,
}: {
  children: React.ReactNode;
  dialogs: {
    name: DialogKey;
    element: React.ReactNode;
  }[];
}) => {
  const [searchParams] = useSearchParams();
  const openDialogs = dialogs.filter(({ name }) => !!searchParams.get(name));
  return (
    <>
      {children}
      {openDialogs.map(dialog => (
        <Suspense key={dialog.name} fallback={<Backdrop />}>
          {dialog?.element}
        </Suspense>
      ))}
    </>
  );
};
